import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import FormInput from '../../components/form/FormInput';
import FormButton from '../../components/form/FormButton';
import clsx from 'clsx';
import { useMutation } from '@tanstack/react-query';
import api from '../../api';
import { toast } from 'react-toastify';
import useLocalStorage from '../../hooks/useLocalStorage';
import { toastStyles } from '../../styles/styles';
import { useTheme } from '../../context/ThemeProvider';
const LoginComponent = ({ tr }) => {
    //   to be used during demo mode
    const navigate = useNavigate();
    const { theme } = useTheme();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({ email: '', password: '' });
    // 
    const { setValue: setUser } = useLocalStorage('user', null);
    const { setValue: setAccessToken } = useLocalStorage('accessToken', null);
    const { setValue: setRefreshToken } = useLocalStorage('refreshToken', null);

    // Hook to handle post request
    const { mutate: login, status } = useMutation({
        mutationFn: (data) => api.auth.signIn(data),
        onSuccess: (data) => {
            toast.success(data?.data?.message, {
                ...toastStyles,
                theme: theme
            });
            setAccessToken(data?.data?.accessToken);
            setRefreshToken(data?.data?.refreshToken);
            setUser(data?.data?.user);
            navigate('/dashboard');
            setFormData({ email: '', password: '' });
            setErrors({ email: '', password: '' });
        },
        onError: (error) => {
            console.error(error);
            toast.error(error?.response?.data, {
                ...toastStyles,
                theme: theme
            });
        }
    });

    const validate = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = tr('emailRequired');
        } else if (!/\S+@\S+\.\S+/.test(values.email)) {
            errors.email = tr('emailInvalid');
        }
        if (!values.password) {
            errors.password = tr('passwordRequired');
        }
        return errors;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
        setErrors({ ...errors, [e.target.id]: '' });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = validate(formData);
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }
        login(formData);
    };

    return (
        <div
            className={clsx(
                'w-full max-w-md mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-md dark:border md:mt-0 xl:p-0',
                'rounded-xl shadow-md hover:shadow-xl',
                'transition-all duration-300 ease-in-out overflow-hidden',
                'border-2 border-gray-200 dark:border-gray-700'
            )}
        >
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                <h1 className={clsx('text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl', 'dark:text-gray-200')}>{tr('description')}</h1>
                <div className="space-y-4 md:space-y-6" action="#">
                    <FormInput values={formData?.email} error={errors?.email} onChange={handleChange} id="email" type="email" label={tr('email')} placeholder={tr('emailPlaceholder')} />
                    <FormInput values={formData?.password} error={errors?.password} onChange={handleChange} id="password" type="password" label={tr('password')} placeholder={tr('passwordPlaceholder')} />
                    <div className="flex items-center justify-between">
                        <NavLink to="#" className="text-sm font-medium text-gray-500 hover:text-[#41A6D7]">
                            {tr('forgotPassword')}
                        </NavLink>
                    </div>
                    <FormButton onClick={handleSubmit}>{status === 'pending' ? 'Loading...' : tr('signIn')}</FormButton>
                    {/* <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                        {tr('dontHaveAccount')}{' '}
                        <NavLink to="/register" className={clsx('font-medium text-primary-600 hover:text-[#41A6D7]', 'dark:text-gray-200')}>
                            {tr('signUp')}
                        </NavLink>
                    </p> */}
                </div>
            </div>
        </div>
    );
};

export default LoginComponent;
